module.exports = __webpack_public_path__ + "img/workflow.714da9e5.svg";